// Hardcoded media files used for template previews and creation
export const HARDCODED_MEDIA = {
  image: {
    file: {
      name: 'prodyt.png',
      type: 'image/png',
      file: null
    },
    preview: '/prodyt.png'
  },
  video: {
    file: {
      name: 'video2.mp4',
      type: 'video/mp4',
      file: null
    },
    preview: '/video2.mp4'
  },
  document: {
    file: {
      name: 'file-sample_150kB.pdf',
      type: 'application/pdf',
      file: null
    },
    preview: '/file-sample_150kB.pdf'
  },
  audio: {
    file: {
      name: 'file_example_MP3_700KB.mp3',
      type: 'audio/mpeg',
      file: null
    },
    preview: '/file_example_MP3_700KB.mp3'
  }
};

// Hardcoded S3 details for media verification
export const HARDCODED_S3_VERIFICATION = {
  bucket: 'whatsapp-campaign',
  media: {
    image: {
      key: 'verify_template_media/image/image.jpg',
      mimeType: 'image/png'
    },
    video: {
      key: 'verify_template_media/video/video.mp4',
      mimeType: 'video/mp4'
    },
    document: {
      key: 'verify_template_media/document/file-sample_150kB.pdf',
      mimeType: 'application/pdf'
    },
    audio: {
      key: 'verify_template_media/audio/file_example_MP3_700KB.mp3',
      mimeType: 'audio/mpeg'
    }
  }
};
 